/* eslint-disable no-unused-vars */
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useForm } from 'react-hook-form';

// Shared layouts
import { Dashboard as DashboardLayout } from 'layouts';

import {
  Portlet,
  PortletHeader,
  PortletLabel,
  PortletContent,
} from 'components';

// Material helpers
import { makeStyles } from '@mui/styles';

// Material components
import { Button, Grid2, TextField } from '@mui/material';

import { FormControl, InputLabel, Select, MenuItem } from '@mui/material';

// Component styles
import styles from './styles';
import { updateDataCardControl } from 'js/actions/onOffAcrtions';
import { useLocation } from 'react-router-dom';

const useStyles = makeStyles(styles);

const defaultSelectValues = {
  rateType: null,
};

export default function UpdateControlCard() {
  const { register, handleSubmit } = useForm({
    defaultSelectValues,
  });
  const classes = useStyles();
  const dispatch = useDispatch();

  const { card } = useLocation().state;
  const user = useSelector((state) => state.user.user);

  const meterAdmin = useSelector((state) => state.user.meter);
  const meterUser = user.meters;
  const meterId =
    meterUser === undefined || meterUser === null
      ? meterAdmin
      : meterUser[0].id;

  const direction = ['01', '02', '03', '04', '05', '06', '07'];

  const [direction_id, setDirection] = React.useState(card.direction_id);

  const onSubmit = (values) => {
    dispatch(updateDataCardControl(values, card));
  };

  const handleDirection = (direction) => {
    setDirection(direction.target.value);
  };

  return (
    <DashboardLayout>
      <div className={classes.root}>
        <Portlet>
          <PortletHeader>
            <PortletLabel title="Tarjeta de Control" />
          </PortletHeader>
          <PortletContent noPadding={true}>
            <form className={classes.form} onSubmit={handleSubmit(onSubmit)}>
              <Grid2 container={true} spacing={4}>
                <Grid2 size={12}>
                  <div className={classes.fields}>
                    <TextField
                      className={classes.textField}
                      defaultValue={card.name}
                      {...register('name')}
                      label="Nombre de Tarjeta de Control"
                      name="name"
                      required
                      variant="filled"
                    />
                    <TextField
                      className={classes.textField}
                      defaultValue={card.description}
                      {...register('description')}
                      label="Descripcion"
                      name="description"
                      required
                      variant="filled"
                    />
                    <TextField
                      className={classes.textField}
                      defaultValue={card.ubication}
                      {...register('ubication')}
                      label="Ubicación"
                      name="ubication"
                      required
                      variant="filled"
                    />
                    <FormControl
                      className={classes.textField}
                      variant="outlined"
                    >
                      <InputLabel id="demo-simple-select-outlined-label">
                        Direccion de Tarjeta
                      </InputLabel>
                      <Select
                        id="demo-simple-select-outlined"
                        {...register('direction_id')}
                        labelId="demo-simple-select-outlined-label"
                        name="direction_id"
                        onChange={handleDirection}
                        value={direction_id}
                      >
                        {direction?.map((el) => (
                          <MenuItem value={el} key={el}>
                            {el}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </div>
                </Grid2>
              </Grid2>

              <Button
                className={classes.signUpButton}
                color="secondary"
                size="large"
                type="submit"
                variant="contained"
              >
                Actualizar
              </Button>
            </form>
          </PortletContent>
        </Portlet>
      </div>
    </DashboardLayout>
  );
}
